<template>
    <b-card>
      <!-- modal begin -->
      <div class="card-header">
        <ul class="nav nav-pills card-header-pills">

          <!-- <li class="nav-item">
            <a class="nav-link disabled">Passcodes</a>
          </li> -->
          <li class="nav-item">
            <div>
              <b-button @click="modalShow = !modalShow" style="background-color:orange; color:#fff;">
                <i class="fa fa-plus-circle"></i> Add
              </b-button>
              <b-modal v-model="modalShow" ok-only ok-variant="secondary" ok-title="Cancel" centered>
                <passcode-form :lockId=lockId></passcode-form>
              </b-modal>
            </div>
          </li>

          <li class="nav-item">
            <b-button type="button" variant="primary" class="float-right" @click="refreshPasscode()" style="background-color:orange !important; color:#fff;margin-left:10px;">
              <i class="icon-refresh" style="background-color:orange; color:#fff;"></i>
            </b-button>
          </li>
        </ul>
      </div>
      <!-- modal end -->
      <b-table responsive="sm" :items="passcodes" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter">

        <template slot="keyboardPwdType" slot-scope="data">
          <div v-if="data.item.keyboardPwdType === 3"><img src="/static/img/temporary.png" width="25px" style="margin-bottom: 5px;"></div>
          <div v-if="data.item.keyboardPwdType === 2"><img src="/static/img/perpetual.png" width="25px" style="margin-bottom: 5px;"></div>

        </template>
        <!-- <template slot="date" slot-scope="data">

          <i class="icon-calendar"></i><small class="text-muted ng-binding">Start: {{(new Date(data.item.sentDate )).toLocaleString('en-GB', {day: 'numeric',  month: 'short',  year: 'numeric'})}}</small>
        </template> -->
        <template slot="startEndDate" slot-scope="data">
          <small class="text-muted ng-binding">
          <div>
            Created: <i class="icon-calendar"></i> {{(new Date(data.item.sentDate)).toLocaleString('en-GB', {day: 'numeric',  month: 'short',  year: 'numeric'})}}
          </div>
          <div style="display: table-cell;" v-if="(new Date(data.item.endDate).getTime() - new Date().getTime()) > 0">
            Period: <i class="icon-calendar"></i>
            {{(new Date(data.item.startDate)).toLocaleString('en-GB', {day: 'numeric',  month: 'short',  year: 'numeric', hour: 'numeric', minute: 'numeric'})}}
          </div>
          <!-- <i class="icon-calendar"></i><small class="text-muted ng-binding">Start: {{(new Date(data.item.startDate)).toLocaleString('en-GB', {day: 'numeric',  month: 'short',  year: 'numeric'})}}</small>
          <br/> -->

          <div v-if="data.item.keyboardPwdType === 3" style="display: table-cell;">
             - {{(new Date(data.item.endDate)).toLocaleString('en-GB', {day: 'numeric',  month: 'short',  year: 'numeric', hour: 'numeric', minute: 'numeric'})}}
          </div>
          <div v-if="data.item.keyboardPwdType === 2" style="display: table-cell;">
             End: &#8734;
          </div>
          </small>
        </template>

        <template slot="action" slot-scope="data">
          <div>
            <b-button type="button" variant="danger" @click.stop="showModal(modalDeleteId(data.item.keyboardPwdId), $event.target)" style="float: left; position: relative;">
              <i class="fa fa-trash-o"></i>
              Delete
            </b-button>
            <b-modal :id="modalDeleteId(data.item.keyboardPwdId)" @ok="handleOk(data.item.keyboardPwdId, modalDeleteId(data.item.keyboardPwdId), $event.target)">
              <div class="modal-window">
                <div class="alert alert-danger">
                  <ul class="fa-ul" style="margin-bottom: 0px;">
                    <li>
                      <i class="fa fa-info-circle fa-li"></i>
                      <p>Are you sure you want to delete the passcode:<br/> <strong>{{ data.item.keyboardPwd }}</strong> ?</p>
                    </li>
                  </ul>
                </div>

            	</div>
            </b-modal>
          </div>

        </template>
      </b-table>
      <nav>
        <b-pagination :total-rows="getRowCount(passcodes)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
      </nav>
    </b-card>
</template>

<script>
import PasscodeForm from '@/views/base/haus/PasscodeForm'
import PasscodeEditForm from '@/views/base/haus/PasscodeEditForm'
let qs = require('qs')
const constants = require('../shared/constants')
const BASE = constants.NEWPORT_CONST.API_URL
const API = BASE + '/api/passcodes/list'
const API_DELETE = BASE + '/api/passcodes/delete'

function postdata (url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      'accessToken': data.accessToken
    },
    method: 'POST'
  })
    .then(res => res.json())
}

async function getData (lockId) {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    lockId: lockId
  }
  let res = await postdata(API, parameters)
  let result = res.list
  return result
}

async function deleteItem (keyboardPwdId, lockId) {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    lockId: lockId,
    keyboardPwdId: keyboardPwdId,
    deleteType: 2
  }
  let res = await postdata(API_DELETE, parameters)
  return res.list
}

export default {
  name: 'passcode-list',
  components: {
    PasscodeForm,
    PasscodeEditForm
  },
  data: () => {
    return {
      modalShow: false,
      modalShowEdit: false,
      passcodes: [],
      fields: {
        keyboardPwd: {
          label: 'Passcode'
        },
        keyboardPwdType: {
          label: 'Type'
        },
        labelPasscode: {
          label: 'Label'
        },
        startEndDate: {
          label: 'Period'
        },
        action: {
          label: 'Action'
        }
      },
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null
    }
  },
  props: ['lockId'],
  mounted () {
    let lockId = this.$route.params.lockId
    getData(lockId).then(response => {
      this.$data.passcodes = response
      this.$root.$on('modalShow', (modalShow) => {
        this.modalShow = modalShow
      })
    })
    this.$root.$on('passcodeList', (dataPasscode) => {
      this.passcodes = dataPasscode
    })
    let loc = location.href
    if (loc.indexOf('?') > 0) {
      if (loc.indexOf('lockDetail') > 0) {
        this.$router.push('/base/lockDetail/' + lockId)
      } else {
        location.href = '/#/base/passcodeList/' + lockId
      }
    }
  },
  methods: {
    modalId (i) {
      return 'modal' + i
    },
    modalDeleteId (i) {
      return 'modaldeletepasscode' + i
    },
    mailto (email) {
      return 'mailto:' + email
    },
    getRowCount (items) {
      return items.length
    },
    openlink (link) {
      location.href = link
    },
    handleOk (id, modalId, button) {
      let lockId = this.$route.params.lockId
      deleteItem(id, lockId).then(response => {
        console.log(response)
        getData(lockId).then(responseRefresh => {
          this.$root.$emit('passcodeList', responseRefresh)
          this.$root.$emit('bv::hide::modal', modalId, button)
        })
      })
    },
    showModal (id, button) {
      this.$root.$emit('bv::show::modal', id, button)
    },
    refreshPasscode () {
      getData(this.$route.params.lockId).then(response => {
        this.$data.passcodes = response
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/haus/PasscodeList.vue